/** Move an enabled-app id from one index to another within the ordered list. */
export function reorderEnabledAppIds(
  ids: readonly string[],
  fromIndex: number,
  toIndex: number
): string[] {
  if (
    fromIndex < 0 ||
    toIndex < 0 ||
    fromIndex >= ids.length ||
    toIndex >= ids.length ||
    fromIndex === toIndex
  ) {
    return [...ids];
  }
  const next = [...ids];
  const [item] = next.splice(fromIndex, 1);
  if (item === undefined) return [...ids];
  next.splice(toIndex, 0, item);
  return next;
}

/** Move an enabled-app id by one step (−1 up / +1 down). */
export function moveEnabledAppId(
  ids: readonly string[],
  appId: string,
  direction: -1 | 1
): string[] {
  const fromIndex = ids.findIndex((id) => id.toLowerCase() === appId.toLowerCase());
  if (fromIndex < 0) return [...ids];
  return reorderEnabledAppIds(ids, fromIndex, fromIndex + direction);
}
